import { render } from "./Hall3En.vue?vue&type=template&id=2cac9f6d"
import script from "./Hall3En.vue?vue&type=script&lang=js"
export * from "./Hall3En.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__